import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/shared/services/request/request.service';
import { SessionStorageService } from 'src/app/shared/services/storage/sessionstorage/sessionstorage.service';


@Injectable({
  providedIn: 'root',
})
export class ModalMaisFiltrosService {
  constructor(
    private _requestService: RequestService,
    private _sessionStorageService: SessionStorageService
  ) {}

  private getAuthHeadersObject(): { [header: string]: string } | undefined {
    const authToken = this._sessionStorageService.buscarTokenAplicacao();
    if (authToken) {
      return {
        Authorization: `Bearer ${authToken}`,
      };
    }
    return undefined;
  }

  buscarFiltroAreasComuns() {
    const headers = this.getAuthHeadersObject();
    if (headers) {
      return this._requestService.requestMethod(
        'work/Search/RealEstate/Filter/ListCommonAreas',
        'GET',
        true,
        null,
        headers
      );
    } else {
      throw new Error('Token de autenticação não encontrado');
    }
  }

  buscarFiltroTiposObras() {
    const headers = this.getAuthHeadersObject();
    if (headers) {
      return this._requestService.requestMethod(
        `work/Search/RealEstate/Filter/ListTypeWork`,
        'GET',
        true,
        null,
        headers
      );
    } else {
      throw new Error('Token de autenticação não encontrado');
    }
  }

  buscarFiltroFaseDaObra() {
    const headers = this.getAuthHeadersObject();
    if (headers) {
      return this._requestService.requestMethod(
        `work/Search/RealEstate/Filter/ListPhaseWork`,
        'GET',
        true,
        null,
        headers
      );
    } else {
      throw new Error('Token de autenticação não encontrado');
    }
  }

  buscarFiltroEstados() {
    const headers = this.getAuthHeadersObject();
    if (headers) {
      return this._requestService.requestMethod(
        `work/Search/RealEstate/Filter/ListStateWork`,
        'GET',
        true,
        null,
        headers
      );
    } else {
      throw new Error('Token de autenticação não encontrado');
    }
  }

  buscarDetalhesApto() {
    const headers = this.getAuthHeadersObject();
    if (headers) {
      return this._requestService.requestMethod(
        `work/Search/RealEstate/Filter/ListAptDetails`,
        'GET',
        true,
        null,
        headers
      );
    } else {
      throw new Error('Token de autenticação não encontrado');
    }
  }

  buscarCadastradaEm() {
    const headers = this.getAuthHeadersObject();
    if (headers) {
      return this._requestService.requestMethod(
        `work/Search/RealEstate/Filter/ListDateRegistered`,
        'GET',
        true,
        null,
        headers
      );
    } else {
      throw new Error('Token de autenticação não encontrado');
    }
  }

  buscarDetalhesCobertura() {
    const headers = this.getAuthHeadersObject();
    if (headers) {
      return this._requestService.requestMethod(
        `work/Search/RealEstate/Filter/ListPenthouseDetails`,
        'GET',
        true,
        null,
        headers
      );
    } else {
      throw new Error('Token de autenticação não encontrado');
    }
  }
}
